import { Component, Input } from '@angular/core'

import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'

@Component({
    selector: 'alert',
    templateUrl: 'alert.modal.html',
    styleUrls: ['./style/modal.scss'],
    standalone: false
})
export class AlertModal {
    @Input() title?: string
    @Input() body?: string
    @Input() extra?: string;
    @Input() cssClass?: string = "info";

    constructor(public activeModal: NgbActiveModal) { }

    buttonText = "OK";
}